<template lang="pug">
  SspLayout(area="tnt")
    .repackage
      form.form-horizontal.row(role="form" @submit.prevent="repack()")
        .col-sm-12
          .panel.panel-default
            .panel-body
              .container-fluid
                .col-sm-6
                    .form-group
                      label.col-sm-3.control-label Parent Code
                      .col-sm-9
                        input.form-control(v-model="form.parentCode")
                    .form-group
                      label.col-sm-3.control-label Actions
                      .col-sm-9
                        select.form-control(v-model="form.operation")
                          option(v-for="action in actions") {{action}}
                    .form-group
                      label.col-sm-3.control-label Location
                      .col-sm-9
                        LocationPicker(v-model="form.location")

                .col-sm-6
                  label.col-sm-3.control-label Child Codes
                  .col-sm-9
                    textarea.form-control(v-model="form.childCodes")
            .panel-footer
              .text-right
                button.btn.btn-primary.ml15(type="submit" :disabled="!isValid") Repackage
                button.btn.btn-default.ml5(type="button" @click="clear") Clear

</template>

<script>
import miniToastr from 'mini-toastr'
import LocationPicker from '@/components/ssp/LocationPicker'
import Util from '@/service/Util'
import TrackNTrace from '@/service/apis/TrackNTrace'

export default {
  data: () => ({
    form: {},
    actions: ['', 'SET', 'APPEND', 'DETACH']
  }),
  created() {
    this.form = this.initalFormData()
  },
  methods: {
    initalFormData() {
      return {
        parentCode: null,
        operation: null,
        location: null,
        childCodes: null
      }
    },
    clear() {
      this.form = this.initalFormData()
    },
    success(operation, parentCode) {
      miniToastr.success(`Codes successfully ${operation} to ${parentCode}`)
    },
    repack() {
      const req = this.createPayload()

      switch (this.form.operation) {
        case 'SET':
          this.handleOperation(TrackNTrace.setChildren(req), req.parent)
          break
        case 'APPEND':
          this.handleOperation(TrackNTrace.appendChildren(req), req.parent)
          break
        case 'DETACH':
          this.handleOperation(TrackNTrace.detachChildren(req), req.parent)
          break
        default:
          this.errorMsg = `${this.operation} is not a valid operation`
      }
    },
    handleOperation(promise, parentCode) {
      promise
        .then(() => {
          this.success(this.form.operation, parentCode)
          this.clear()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    createPayload() {
      const codes = Util.sanitizeCodes(this.form.childCodes)

      const req = {
        children: {
          child: codes
        },
        locationId: this.form.location.id,
        parent: Util.sanitizeCode(this.form.parentCode)
      }
      return req
    }
  },
  computed: {
    isValid() {
      return this.form.parentCode && this.form.operation && this.form.childCodes && this.form.location
    }
  },
  components: {
    LocationPicker
  }
}
</script>

<style lang="scss">
.repackage {
  textarea {
    min-height: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/registration/Repackage.vue